import React from "react";
import './Project.css';
import { Container,  Row, Col, Tabs, Tab} from 'react-bootstrap';
import { Link } from "react-router-dom";
import { workData } from "data";
import { useEffect } from "react";
import WOW from 'wowjs';

const Project = () => {
    useEffect(() => {
        document.title = 'Works | Quadrics';
      });
    useEffect(() => {
        new WOW.WOW({
          live: false
        }).init();
      }, [])
    return (
        <div>
            <section className="works-section">
                <Container>
                    <h2>Works</h2>
                    <div className="tab-content">
                    <Tabs defaultActiveKey="clientType" id="uncontrolled-tab-example" className="mb-3 justify-content-center">
                        <Tab eventKey="clientType" title="Type of Client" className="clientType">
                            <Row>
                                <h5>Real Estate</h5>
                            </Row>
                            <Row className="mx-0">
                                {workData.filter((work) => work.sector === 'Real Estate').map((work) => (
                                    <Col md={4} className="pb-3" key={work.id}>
                                        <Link to={`/single/${work.id}`}>
                                        <img
                                            src={work.gallery[0]}
                                            className="clickable-img img-fluid py-3 w-100"
                                            alt={work.name}
                                        />
                                        </Link>
                                    </Col>
                                    ))
                                }
                            </Row>
                            <Row className="mx-0">
                                <h5>Food & Beverages</h5>
                            </Row>
                            <Row>
                                {workData.filter((work) => work.sector === 'Food & Drinks').map((work) => (
                                    <Col md={4} className="pb-3" key={work.id}>
                                        <Link to={`/single/${work.id}`}>
                                        <img
                                            src={work.gallery[0]}
                                            className="clickable-img img-fluid py-3 w-100"
                                            alt={work.name}
                                        />
                                        </Link>
                                    </Col>
                                    ))
                                }
                            </Row>
                        </Tab>
                        <Tab eventKey="workType" title="Type of Work">
                            <div className="worktype">
                                <h5 className="pt-3">Brand Identity</h5>
                                <Row>
                                {workData.filter((work) => work.discipline.includes('Brand Identity')).map((work) => (
                                    <Col md={4} className="pb-3" key={work.id}>
                                        <Link to={`/single/${work.id}`}>
                                        <img
                                            src={work.gallery[0]}
                                            className="clickable-img img-fluid py-3 w-100"
                                            alt={work.name}
                                        />
                                        </Link>
                                    </Col>
                                ))}
                                </Row>
                            </div>
                            <div className="worktype">
                                <h5>Digital Design</h5>
                                <Row>
                                {workData.filter((work) => work.discipline.includes('Digital Design')).map((work) => (
                                    <Col md={4} className="pb-3" key={work.id}>
                                        <Link to={`/single/${work.id}`}>
                                        <img
                                            src={work.gallery[0]}
                                            className="clickable-img img-fluid py-3 w-100"
                                            alt={work.name}
                                        />
                                        </Link>
                                    </Col>
                                ))}
                                </Row>
                            </div>
                            <div className="worktype">
                                <h5>Editorial & Prints</h5>
                                <Row>
                                {workData.filter((work) => work.discipline.includes('Editorial & Prints')).map((work) => (
                                    <Col md={4} className="pb-3" key={work.id}>
                                        <Link to={`/single/${work.id}`}>
                                        <img
                                            src={work.gallery[0]}
                                            className="clickable-img img-fluid py-3 w-100"
                                            alt={work.name}
                                        />
                                        </Link>
                                    </Col>
                                ))}
                                </Row>
                            </div>
                            <div className="worktype">
                                <h5>Awards Submission</h5>
                                <Row>
                                {workData.filter((work) => work.discipline.includes('Awards Submission')).map((work) => (
                                    <Col md={4} className="pb-3" key={work.id}>
                                        <Link to={`/single/${work.id}`}>
                                        <img
                                            src={work.gallery[0]}
                                            className="clickable-img img-fluid py-3 w-100"
                                            alt={work.name}
                                        />
                                        </Link>
                                    </Col>
                                ))}
                                </Row>
                            </div>
                        </Tab>
                        <Tab eventKey="allProjects" title="All Projects">
                            <h5 className="pt-3">All Projects</h5>
                            <Row>
                            {workData.map((work) =>
                                <Col md={4} className="pb-3">
                                    <Link
                                        to={`/single/${work.id}`}
                                        >
                                        <img
                                            key={14}
                                            src={work.gallery[0]}
                                            className="clickable-img img-fluid py-3 w-100"
                                            alt={work.name}
                                        />
                                    </Link>
                                </Col>
                            )}
                            </Row>
                        </Tab>
                    </Tabs>
                    </div>
                </Container>
            </section>
        </div>
    );
}
export default Project;